export enum SalePeriod {
  BEFORE = "before",
  BLACK_FRIDAY = "blackFriday",
  CYBER_MONDAY = "cyberMonday",
  AFTER = "after"
}

const DATES = {
  blackFridayStart: new Date(2025, 10, 24, 0, 0), // 24 nov 2025
  blackFridayEnd: new Date(2025, 10, 30, 23, 59), // 30 nov 2025
  cyberMondayStart: new Date(2025, 11, 1, 0, 0), // 1 dic 2025
  cyberMondayEnd: new Date(2025, 11, 1, 23, 59) // 1 dic 2025
}

/**
 * Devuelve el periodo actual: BEFORE, BLACK_FRIDAY, CYBER_MONDAY o AFTER
 */
export const getSalePeriod = (date: Date = new Date()): SalePeriod => {
  if (date >= DATES.blackFridayStart && date <= DATES.blackFridayEnd) return SalePeriod.BLACK_FRIDAY
  if (date >= DATES.cyberMondayStart && date <= DATES.cyberMondayEnd) return SalePeriod.CYBER_MONDAY
  if (date < DATES.blackFridayStart) return SalePeriod.BEFORE
  return SalePeriod.AFTER
}
